import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { FeedbackFile } from "../../../Models/FeedbackFile";
import pdfImage from "../../../Images/pdf.jpg";
import pptImage from "../../../Images/powerpoint.jpg";
import docImage from "../../../Images/word.jpg";
import xlsImage from "../../../Images/excel.jpg";
import txtImage from "../../../Images/text.jpg";
import vidImage from "../../../Images/video.png";
import gifImage from "../../../Images/gif.png";
import styles from "../../../Styles/FeedbackFileDisplay.module.scss";

const uuid = require("uuid");

type Props = {
  files: FeedbackFile[];
};

export default class FeedbackFileDisplay extends React.Component<Props> {
  getImageUrl = (file: FeedbackFile) => {
    switch (file.extension) {
      case ".pdf":
        return pdfImage;
      case ".ppt":
        return pptImage;
      case ".pptx":
        return pptImage;
      case ".docx":
        return docImage;
      case ".doc":
        return docImage;
      case ".xlsx":
        return xlsImage;
      case ".xls":
        return xlsImage;
      case ".csv":
        return xlsImage;
      case ".txt":
        return txtImage;
      case ".mp4":
        return vidImage;
      case ".gif":
        return gifImage;
      default:
        return "";
    }
  };

  render() {
    return (
      <ListGroup>
        {this.props.files.map((item: FeedbackFile) => (
          <ListGroupItem
            className={styles.item}
            tag="a"
            href={item.url}
            target="_blank"
            key={uuid()}
          >
            <img src={this.getImageUrl(item)} className={styles.itemImage} />
            <span className={styles.itemFileName}>{item.filename}</span>
            {item.extension === ".mp4" && (
              <>
                <br />
                <span className={styles.itemWarning}>
                  Right Click + &quot;Save Link As...&quot; to view Video files{" "}
                </span>
              </>
            )}
          </ListGroupItem>
        ))}
      </ListGroup>
    );
  }
}
